import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export const ActionLoaded = ({ loadValue, circleActiveColor, circlePassiveColor, stepCount }) => {
    return (
        <div className="action-loaded-box">
            {/*<CircularProgress*/}
            {/*    enableTrackSlot variant="determinate"*/}
            {/*    value={loadValue}*/}
            {/*    size={20}*/}
            {/*    color='primary'*/}
            {/*/>*/}

            <div style={{ position: 'relative', width: 18, height: 18 }}>
                {/* Background track */}
                <CircularProgress
                    variant="determinate"
                    value={100}
                    size={18}
                    thickness={4}
                    sx={{
                        color: circlePassiveColor ? circlePassiveColor : '#EBF2FD',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                    }}
                />

                {/* Actual progress */}
                <CircularProgress
                    variant="determinate"
                    value={loadValue}
                    size={18}
                    thickness={4}
                    sx={{
                        color: circleActiveColor ? circleActiveColor : '#0B5DCF',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                    }}
                />
            </div>

            <p className="load-percent-box" style={circleActiveColor ? { color: circleActiveColor } : {}}>
                {`${loadValue ? Math.round(loadValue) : 0}%`}
            </p>

            {stepCount && <div className="step-count-box">{stepCount}</div>}
        </div>
    );
};
